import { render, staticRenderFns } from "./PostTaxi.vue?vue&type=template&id=6442a355&scoped=true"
import script from "./PostTaxi.vue?vue&type=script&lang=js"
export * from "./PostTaxi.vue?vue&type=script&lang=js"
import style0 from "./PostTaxi.vue?vue&type=style&index=0&id=6442a355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442a355",
  null
  
)

export default component.exports